import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { callAPI } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';

export const fetchSavedLogos = createAsyncThunk(
  'logo/fetchSavedLogos',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await callAPI(
        apiUrls.aiLogosListing,
        params,
        "GET",
        {}
      );

      if (response?.data?.success) {
        return response.data;
      } else {
        return rejectWithValue(response?.data?.message || 'Failed to fetch logos');
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Network error');
    }
  }
);

const logoSlice = createSlice({
  name: 'logo',
  initialState: {
    logos: [],
    loading: false,
    error: null,
    pagination: {
      current_page: 1,
      last_page: 1,
      per_page: 10,
      total: 0,
      from: 0,
      to: 0
    }
  },
  reducers: {
    clearLogoError: (state) => {
      state.error = null;
    },
    clearLogos: (state) => {
      state.logos = [];
      state.pagination = {
        current_page: 1,
        last_page: 1,
        per_page: 10,
        total: 0,
        from: 0,
        to: 0
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSavedLogos.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSavedLogos.fulfilled, (state, action) => {
        state.loading = false;
        state.logos = action.payload.data || [];
        state.pagination = {
          current_page: action.payload.current_page || 1,
          last_page: action.payload.last_page || 1,
          per_page: action.payload.per_page || 10,
          total: action.payload.total || 0,
          from: action.payload.from || 0,
          to: action.payload.to || 0
        };
      })
      .addCase(fetchSavedLogos.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { 
  clearLogoError, 
  clearLogos
} = logoSlice.actions;

export default logoSlice.reducer;